<app-loader [loading]="!uploadedFiles || !document" [fullPage]="true"></app-loader>
<section *ngIf="uploadedFiles && document" class="simulation grid-container grid-container--section no-gutter-mobile" data-overload-controller="AdhesionPegaseCtrl">
    <form>
        <fieldset class="simulation__step" data-ng-form="adhesionForm" name="adhesionForm">
            <legend style="display: none">Medical Document Upload</legend>
            <div data-ui-view="adhesionSteps">
                <section class="document-selection">
                    <div class="simulation__group">
                        <div>
                            <section class="document-selection-type">
                                <div class="document-selection-type__header">
                                    <h3 class="document-selection-type__header-title">
                                        <span>{{ document.type }}</span>
                                    </h3>
                                    <div class="document-selection-type__header-subtitle">
                                        {{ 'documentselectiontype.header.title.note' | i18n }}
                                    </div>
                                    <div class="document-selection-type__header-descriptiontitle">
                                        {{ 'documentselectiontype.header.title.description' | i18n }}
                                    </div>
                                    <div class="document-selection-type__header-description">
                                        <div>
                                            {{ 'documentselectiontype.header.title.exp3' | i18n }}
                                        </div>
                                        <em class="document-selection-type__header-description--details" [innerHtml]="'documentselectiontype.header.title.exp3.details' | i18n"> </em>
                                    </div>
                                </div>
                                <div class="document-selection-type__content">
                                    <div class="document-selection-type__buttons">
                                        <div class="button button--download button--noBackground">
                                            <input
                                                #fileInput
                                                type="file"
                                                class="document-selection-type__button-input"
                                                (click)="removeTarget($event.target)"
                                                (change)="handleFilesUpload($event.target.files)"
                                                data-tag-commander=""
                                                [appTagCommander]="'tagCo.documentselection.documentselectiontype.desktop.import.button'"
                                                accept=".jpg,.jpeg,.png,.pdf"
                                                multiple=""
                                                input-model-reader="documentSelectionType.libraryFiles"
                                            />
                                            <div class="document-selection-type__button-image document-selection-type__button-image--left"></div>
                                            <div class="document-selection-type__button-label">
                                                <span id="authorisationPhotoDesktopButton" class="hide-mobile button-text">{{ 'documentselectiontype.button.desktop.load-document.exp3' | i18n }}</span>
                                                <span id="authorisationPhotoMobileButton" class="hide show-mobile button-text" (click)="openCameraOrPhototheque('phototheque')">
                                                    {{ 'documentselectiontype.button.mobile.load-document.exp3' | i18n }}</span
                                                >
                                            </div>
                                        </div>
                                        <button
                                            id="authorisationPhotoMobileButton"
                                            type="button"
                                            data-tag-commander=""
                                            (click)="openCameraOrPhototheque('camera')"
                                            [appTagCommander]="'tagCo.documentselection.documentselectiontype.desktop.gotomobile.button'"
                                            class="hide show-mobile button button--download button--noBackground'"
                                        >
                                            <div class="document-selection-type__button-image document-selection-type__button-image--right"></div>
                                            <div class="document-selection-type__button-label">
                                                <span class="button-text"> {{ 'documentselectiontype.button.mobile.scan-document.exp3' | i18n }}</span>
                                            </div>
                                        </button>

                                        <button
                                            id="authorisationPhotoDesktopButton"
                                            type="button"
                                            data-tag-commander=""
                                            (click)="openCamera = true"
                                            [appTagCommander]="'tagCo.documentselection.documentselectiontype.desktop.gotomobile.button'"
                                            class="button button--download button--noBackground hide-mobile"
                                        >
                                            <div class="document-selection-type__button-image document-selection-type__button-image--right"></div>
                                            <div class="document-selection-type__button-label">
                                                <span class="button-text"> {{ 'documentselectiontype.button.desktop.scan-document.exp3' | i18n }}</span>
                                            </div>
                                        </button>
                                    </div>
                                    <div class="hide show-mobile document-selection-type__files" id="authorisationPhotoMobileButton" *ngIf="uploadedFiles.length > 0">
                                        <div class="document-selection-type__files__count-label">
                                            <div class="document-selection-type__files__count-label__text">
                                                <span
                                                    >{{ 'documentselectiontype.documents.scan.pages.download.exp3' | i18n }}
                                                    <span *ngIf="uploadedFiles.length === 1">({{ uploadedFiles.length }} page)</span>
                                                    <span *ngIf="uploadedFiles.length > 1">({{ uploadedFiles.length }} pages)</span></span
                                                >
                                            </div>
                                            <div class="document-selection-type__files__count-label__icon" (click)="toggleConfirmFilesDeleteModal()">
                                                <img alt="" [appAssetSrc]="'assets/images/close-circle-o.svg'" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="hide-mobile document-selection-type__files" id="authorisationPhotoDesktopButton" *ngIf="uploadedFiles.length > 0">
                                        <div class="document-selection-type__files__count-label">
                                            <div class="document-selection-type__files__count-label__text">
                                                <span>{{ 'documentselectiontype.documents.scan.pages.download.exp3' | i18n }}</span>
                                            </div>
                                            <div class="document-selection-type__files__count-label__icon" (click)="toggleConfirmFilesDeleteModal()">
                                                <img alt="" [appAssetSrc]="'assets/images/close-circle-o.svg'" />
                                            </div>
                                        </div>
                                        <ul class="hide-mobile document-selection-type__files__list">
                                            <li *ngFor="let file of uploadedFiles">
                                                {{ file.name }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="document-selection-type__footer footer-top-margin">
                                    <div class="grid-6 grid-mobile-4">
                                        <button
                                            type="button"
                                            class="button button--grey button--previous float-left"
                                            routerLink="/souscription/document-medicale/document-list"
                                            data-tag-commander=""
                                            [appTagCommander]="'tagCo.documentselection.contractualselection.previous.button'"
                                        >
                                            {{ 'global.button.return-to-list' | i18n }}
                                        </button>
                                    </div>
                                    <div class="grid-6 grid-mobile-4">
                                        <button
                                            type="button"
                                            data-tag-commander=""
                                            [appTagCommander]="'tagCo.documentselection.documentselectiontype.submit.button'"
                                            class="button button--primary button--next float-right"
                                            (click)="handleSumbit()"
                                            [disabled]="uploadedFiles.length === 0"
                                        >
                                            {{ 'documentselectiontype.button.next.exp3' | i18n }}
                                        </button>
                                    </div>
                                </div>
                                <app-send-docs-by-post-component></app-send-docs-by-post-component>
                            </section>
                        </div>
                    </div>
                </section>
            </div>
        </fieldset>
    </form>
</section>

<app-jouve-warning-modal-component [visibility]="showJouveWarningModal" [errorKey]="errorKey" (sendDocument)="handleSendDocument()" (rescanDocument)="handleRescanDocument()"> </app-jouve-warning-modal-component>

<app-small-loader-component [visibility]="showSmallLoader" [content]="smallLoaderContent" [success]="uploadSuccess"> </app-small-loader-component>
<app-validation-modal-component
    [modalTitle]="'global.warning'"
    [content]="'documentselectiontype.modal.body.delete'"
    [visibility]="confirmFilesDeleteModal"
    [showInfoIcon]="false"
    [buttonLeft]="'global.no'"
    [buttonRight]="'global.yes'"
    (rightClick)="deleteFiles()"
    (leftClick)="toggleConfirmFilesDeleteModal()"
    (crossClick)="toggleConfirmFilesDeleteModal()"
>
</app-validation-modal-component>
<app-error-small-modal [title]="'documentselectiontype.modal.error.title'" [content]="errorModalContent" [closeButton]="'global.close'" [(visibility)]="showErrorModal"> </app-error-small-modal>
<app-error-small-modal
    [title]="'documentselectiontype.modal.error.title'"
    [content]="'documentselectiontype.modal.error.upload.message'"
    [closeButton]="'global.close'"
    [(visibility)]="showUploadErrorModal"
    (visibilityChange)="deleteFiles()"
>
</app-error-small-modal>
<app-mobile-photo-modal
    [modalTitle]="'documentselectiontype.modal.sms.title.phone'"
    [content]="'documentselectiontype.modal.sms.message'"
    [telephone]="telephone"
    [visibility]="openCamera && !getSms"
    (crossClick)="openCamera = false"
    [icon]="'iconblock iconblock--sms sms-modal__iconblock'"
    [buttonRight]="'documentselectiontype.modal.sms.receive'"
    (rightClick)="showCodeModal()"
>
</app-mobile-photo-modal>

<app-mobile-code-modal
    [modalTitle]="'documentselectiontype.modal.sms.title.code'"
    [visibility]="getSms"
    [codeMobile]="codeMobile"
    (crossClick)="getSms = false"
    [buttonRight]="'documentselectiontype.modal.sms.resend'"
    [loading]="iconLoading"
    (rightClick)="getnewCode()"
    (leftClick)="getSms = false"
>
</app-mobile-code-modal>
<app-validation-modal-component
    [modalTitle]="'global.button.autorisation'"
    [content]="'documentselectiontype.modal.autorisation.library.body'"
    [visibility]="showAuthorisationPhototheque"
    [buttonLeft]="'global.button.refuse'"
    [showInfoIcon]="true"
    [buttonRight]="'global.button.agree'"
    (rightClick)="saveAuthorisationPhotothequeOrCamera('CONSENTEMENTS_PHOTOTEQUE')"
    (leftClick)="showAuthorisationPhototheque = false"
    (crossClick)="showAuthorisationPhototheque = false"
>
</app-validation-modal-component>
<app-validation-modal-component
    [modalTitle]="'global.button.autorisation'"
    [content]="'documentselectiontype.modal.autorisation.photo.body'"
    [visibility]="showAuthorisationCamera"
    [buttonLeft]="'global.button.refuse'"
    [showInfoIcon]="true"
    [buttonRight]="'global.button.agree'"
    (rightClick)="saveAuthorisationPhotothequeOrCamera('CONSENTEMENTS_APPAREIL_PHOTO')"
    (leftClick)="showAuthorisationCamera = false"
    (crossClick)="showAuthorisationCamera = false"
>
</app-validation-modal-component>

<app-simple-message-modal
    [visibility]="showMaxAttempsModal"
    [modalTitle]="'documentselectiontype.modal.error.title'"
    [content]="'modal.pulling.error.content'"
    [closeButton]="'global.close'"
    [icon]="'iconblock modal-info__iconblock'"
    [centered]="false"
></app-simple-message-modal>
